<template>
    <div class="info-modal hide">

        <div class="info-modal-content">
            <button class="close-btn" @click="closeModal"><img src="@/assets/img/modal/close.svg" /></button>

            <div class="basic-content">
                <h2>PREMB-R AM/PM<sup>1,2</sup></h2>

                <p><b>The PREMB-R AM assesses the difficulty of early morning functioning</b> using 3 items (getting out
                    of
                    bed,
                    getting ready for the day, and arguing or struggling excessively). </p>

                <p><b>The PREMB-R PM assesses the difficulty of late afternoon and evening functioning</b> using 8 items
                    (completing homework, sitting through evening meal, getting ready for bed, etc). </p>

                <p>Both the AM and PM assessments are clinician-rated based on parent interviews in which they rate
                    their
                    child’s functional impairment on a severity scale from 0 to 3.</p>

                <p><b style="color:#30368C">0 = None<br />
                        1 = Mild<br />
                        2 = Moderate<br />
                        3 = Severe<br />
                    </b>
                </p>



            </div>
            <div class="refs">
                <p><b>References: 1.</b> Childress AC, Cutler AJ, Marraffino A, et al. A randomized, double-blind,
                    placebo-controlled study of HLD200, a delayed-release and extended-release
                    methylphenidate, in children with attention-deficit/hyperactivity disorder: an evaluation of safety
                    and efficacy throughout the day and across settings. <i>J Child Adolesc
                        Psychopharmacol</i>. 2020;30(1):2-14. <b>2.</b> Pliszka SR, Wilens TE, Bostrom S, et al.
                    Efficacy and safety of HLD200, delayed-release and extended-release methylphenidate, in
                    children with attention-deficit/hyperactivity disorder. <i>J Child Adolesc Psychopharmacol</i>.
                    2017;27(6):474-482.</p>
            </div>

        </div>

    </div>
</template>

<script>
export default {


    props: {
        showModal: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        if (this.showModal == true) {
            document.body.classList.add("overflow")
            this.$el.classList.remove('hide')
        }
    },
    watch: {
        showModal(newValue, oldValue) {
            console.log(newValue);
            if (newValue === true) {
                this.modalActive();
            }
        }
    },

    methods: {
        modalActive: function () {
            document.body.classList.add("overflow")
            this.$el.classList.remove('hide')
        },

        closeModal() {
            document.body.classList.remove("overflow")
            this.$el.classList.add('hide')
            this.$emit('closeModal')
        },
    }

}
</script>

<style lang="scss" scoped>
.info-modal-content .basic-content {
    padding-right: 50px;
}

.info-modal-content {
    p {
        font-size: 20px;
        line-height: 1.1;
    }
}
</style>